import React, { lazy, Suspense } from 'react';
import totalData from '../../json/data.json'; // Assuming your fields are in a JSON file

// Dynamically import DynamicEditForm
const DynamicEditForm = lazy(() => import('../../components/DynamicEditFormTest/DynamicEditForm'));

const AdminEditProductPage = () => {
  const fields = totalData[19].AdminProjects; // Fetch fields from JSON or source
  const apiUrl = 'https://pranusha.vercel.app/projects'; // API URL for fetching/editing product
  const successRedirect = '/admin/projects'; // Where to redirect after a successful update

  return (
    <div>
      <h1 className='edit-header'>Edit Product</h1>
      {/* Suspense to show loading state while the component is being loaded */}
      <Suspense fallback={<p>Loading form...</p>}>
        <DynamicEditForm
          fields={fields}
          apiUrl={apiUrl}
          successRedirect={successRedirect}
        />
      </Suspense>
    </div>
  );
};

export default AdminEditProductPage;




